import { forwardRef } from 'react';
import MuiSettingsIcon from '@mui/icons-material/Settings';
import type { SvgIconProps } from '@mui/material';

const SettingsIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <MuiSettingsIcon ref={ref} {...props} />
));

export default SettingsIcon;
